export const focusNextElement = ({ target, key }: any) => {
	if (key !== `Enter`) return
	const nextElementFocus = document.querySelector(`[tabindex="${parseInt((target as any).attributes.tabindex.value) + 1}"]`)
	if (nextElementFocus) (nextElementFocus as any).focus()
}